export const ITEM_WISHLIST_STATE = {
  ITEM_WISHLISTED: 0,
  ADD_TO_CART: 1,
  REMOVE_FROM_WISHLIST: 3,
  ORDER_PLACED: 2,
};

export const WISHLIST_FEATURE_STATUS = {
  WISHLIST_INACTIVE: -1,
  WISHLIST_DISABLED: 0,
  WISHLIST_ACTIVE: 1,
};
